import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import React from 'react'

const bugsnagClient = bugsnag('a6201c98bfc114ca639299dc02d8e510')
bugsnagClient.use(bugsnagReact, React)
export default bugsnagClient


// WEBPACK FOOTER //
// ./src/utils/BugSnagClient.js